<template>
  <ResponsiveLayout
    sticky-actions
    :progress="progress"
    :show-kaia-logo="false"
    :show-lang-picker="false"
    theme="blue-background"
  >
    <template #header_start>
      <ButtonBack @click="emit('back')" />
    </template>

    <div class="kds-main-wrapper">
      <div class="testimonial-card">
        <p class="kds-typography-paragraph-large kds-typography-center">
          {{ $t('eu__self_test_pain_reflection__quote') }}
        </p>
        <div class="testimonial-card__attribution">
          <img
            :src="avatarImage"
            alt=""
            class="testimonial-card__avatar"
          />
          <span
            class="kds-typography-ui-subtle-medium kds-color-text-secondary"
          >
            {{ $t('eu__self_test_pain_reflection__attribution') }}
          </span>
        </div>
      </div>
    </div>

    <template #actions>
      <BaseButton
        :text="$t('eu__self_test_reflection__cta')"
        data-qa="submit"
        @click="handleNextEvent"
      />
    </template>
  </ResponsiveLayout>
</template>

<script setup>
import BaseButton from '@shared/components/BaseButton.vue'
import ButtonBack from '@shared/components/ButtonBack.vue'
import ResponsiveLayout from '@shared/components/ResponsiveLayout.vue'
import avatarImage from '@shared/assets/img/testimonial_avatar_female.svg'

defineProps({
  progress: {
    type: Number,
    default: null,
  },
  handleNextEvent: {
    type: Function,
    default: () => {},
  },
})

const emit = defineEmits(['back'])
</script>

<style scoped lang="scss">
.testimonial-card {
  display: flex;
  flex-direction: column;
  gap: $kds-space-2_5x;
  background-color: $kds-color-background-base;
  border-radius: $kds-space-1_5x;
  padding: $kds-space-3x $kds-space-2_5x;
}

.testimonial-card__attribution {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: $kds-space-1x;
}

.testimonial-card__avatar {
  width: $kds-space-6x;
  height: $kds-space-6x;
  flex-shrink: 0;
}
</style>
